<template>
    <div
        class="component-video"
        :class="classVideo"
    >
        <div class="video-container">
            <video
                :src="data.video.url"
                :poster
                class="video"
                controls
            ></video>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { ComponentVideoFragment } from '@/graphql/api'
import { assertNever } from '@/helpers'

const props = defineProps<{
    data: ComponentVideoFragment
    poster?: string
}>()

const classVideo = computed(() => {
    switch (props.data.videoWidth) {
        case 'CONTENT':
            return 'content-width'
        case 'EXTENDED_CONTENT':
            return 'extended-content-width'
        case 'FULL':
            return 'full-width'
        default:
            return assertNever(props.data.videoWidth, 'content-width')
    }
})
</script>

<style lang="scss" scoped>
.component-video {
    width: 100%;

    &.extended-content-width {
        .video-container {
            max-width: 1140px;
            height: auto;
            margin: 0 auto;
        }
    }

    &.content-width {
        .video-container {
            max-width: 680px;
            height: auto;
            margin: 0 auto;
        }
    }

    &.full-width {
        .video-container {
            max-width: 100%;
            height: auto;
            margin: 0 auto;
        }
    }

    .video-container {
        width: 100%;
        margin: 0 auto;

        .video {
            width: 100%;
            aspect-ratio: 16/9;
        }
    }
}
</style>
